import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IMap } from "../../models/storeModels/IMap";
import { logout } from "../../features/auth";

function getInitialState() {
    const initialState: IMap = {
        mapPosition: {  // Объект для хранения долготы и широты
            zoom: null,
            latitude: null,
            longitude: null,
            extent: null
        },
        bbox: null,
        rosreestrInfo: [],
        coordsType: 'decimal',
        geolocationSwitchOn: false,
        isMapHaveObject: true,
        isCoordTypeButtonClicked: false,
        isDiagnosticsCardEnabled: false,
        highlightObjectOnMap: false,
        highlightObjectWKTGeometry: null,
        highlightObjectGeoJSON: null,
        highlightObjectStyleConfig: null,
        geoMarkerList: [],
        overlayList: [],
        figureList: [],
    }
    return initialState
}

export const mapSlice = createSlice({
    name: 'map',
    initialState: getInitialState(),
    reducers: {
        setMapPosition: (state, action: PayloadAction<any>) => {
            state.mapPosition = action.payload
        },
        setMapBbox(state, action: PayloadAction<any>) {
            state.bbox = action.payload
        },
        setRosreestrInfo: (state, action) => {
            const rosreestrInfo = action.payload;
            state.rosreestrInfo = rosreestrInfo;
        },
        applyMapObject(state, action: PayloadAction<{ have: boolean }>) {
            state.isMapHaveObject = action.payload.have
        },
        applyCoordTypeButton(state, action: PayloadAction<{ clicked: boolean }>) {
            state.isCoordTypeButtonClicked = action.payload.clicked
        },
        applyCoordType(state, action: PayloadAction<string>) {
            state.coordsType = action.payload
        },
        applyShowDiagnosticsCard(state, action: PayloadAction<{ clicked: boolean }>) {
            state.isDiagnosticsCardEnabled = action.payload.clicked
        },
        geolocationSwitchOn(state, action: PayloadAction<{ turnedOn: boolean }>) {
            state.geolocationSwitchOn = action.payload.turnedOn
        },
        highlightObjectOnMap(state, action: PayloadAction<boolean>) {
            state.highlightObjectOnMap = action.payload
        },
        setHighlightObjectWKTGeometry(state, action: PayloadAction<any>) {
            state.highlightObjectWKTGeometry = action.payload
        },
        setHighlightObjectGeoJSON(state, action: PayloadAction<any>) {
            state.highlightObjectGeoJSON = action.payload
        },
        // Храним в Redux только сериализуемый конфиг стиля (plain object),
        // а реальный ol/style/Style создаём уже в MapWidget перед рендером на карте.
        setHighlightObjectStyleConfig(state, action: PayloadAction<any>) {
            state.highlightObjectStyleConfig = action.payload
        },
        setGeoMarkerList(state, action: PayloadAction<any>) {
            state.geoMarkerList = action.payload
        },
        setOverlayList(state, action: PayloadAction<any>) {
            state.overlayList = action.payload
        },
        // Фигуры для отрисовки поверх карты (линии/окружности/полигоны и т.п.)
        setFigureList(state, action: PayloadAction<any>) {
            state.figureList = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    applyCoordTypeButton,
    applyCoordType,
    setMapBbox,
    applyShowDiagnosticsCard,
    geolocationSwitchOn,
    applyMapObject,
    setMapPosition,
    setRosreestrInfo,
    highlightObjectOnMap,
    setHighlightObjectWKTGeometry,
    setHighlightObjectGeoJSON,
    setHighlightObjectStyleConfig,
    setGeoMarkerList,
    setOverlayList,
    setFigureList,
} = mapSlice.actions
export const mapReducer = mapSlice.reducer;
